import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'
import { ActivatedRoute, Router } from '@angular/router';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ProcessBills/processBills.html'
})

export class ProcessBillsComponent implements OnInit {
    constants: Constants;
    projectList: any = [];
    projectListNew: any = [];
    timesheetItems: any = [];
    siteUserItems: any = [];
    userDetail: any;
    userList: any = [];
    teamList: any = [];
    taskgroupList: any = [];
    taskTypeList: any = [];
    taskTypeSortList: any = [];
    NewtaskTypeSortList: any = [];
    displayData: any = [];
    UpdateList: any = [];
    objSiteUserItem: any = [];
    newTaskGroupList: any = [];
    selfuser: boolean = true;
    public showLoader = false;
    selectAll: any = false;
    selectedTimesheetItems: string = "";
    IsDisabled: boolean = true;
    NotBillable:Number=0;

    filter: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'), 'TeamId': "", 'UserId': "" };

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        //  this.filter={'TeamId': this.timesheetItems.TeamID, 'UserId': this.timesheetItems.SiteUserId}
        this.filter.TeamId = "";
    }

    ngOnInit() {

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        this.filter.FromDate = newDate;
        this.GetTimesheetForProcess(false);
        this.GetUserListbyproj(); 
        this.GetProjectList(0);
    }

    ngAfterViewInit() {


        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });


        $('#userIdFilter').select2().val("").trigger("change");
        $('#userIdFilter').on(
            'change',
            (e) => this.filter.UserId = jQuery(e.target).val()
        );

    }

    GetUserListbyproj() {
        //   this.filter.UserId="";
        var teamId = this.userDetail.TeamID;

        this.showLoader = true;
        this._httpService.ajaxPost('Users/GetUsers', {
            "IsActive": 1,
            "Team": this.userDetail.TeamID,
            "UserId": this.userDetail.SiteUserId
            }).subscribe(
                data => {
                    this.userList = data["Users"];
                    $(".project").val('').selectpicker('refresh');
                },
                err => {
                    console.log("GetUserList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    GetProjectList(val) {
        this.filter.ProjectId = "";
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0 && val == "") {
            UserId = this.userDetail.SiteUserId;
            TeamId = this.userDetail.TeamID;
        }
        else {
            UserId = val;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetAssignedProject",
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 0, "UserId": UserId }).subscribe(
                data => {
                    this.projectList = data["ProjectList"];
                },
                err => {
                    console.log("GetProjectList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    GetTimesheetForProcess(flag: boolean) {
        this.showLoader = true;
        this.selfuser = flag;
        var UserId = 0
        if (this.filter.UserId == "") {
            //UserId = this.userDetail.SiteUserId
        }
        else {
            UserId = this.filter.UserId
        }
        var TeamId = "0"
        if (this.filter.TeamId == "") {
            //TeamId = this.userDetail.TeamID
            TeamId = this.constants.TeamId;
        }
        else {
            TeamId = this.filter.TeamId
        }
        this._httpService.ajaxPost("TimesheetProcess/GetTimesheetForProcess",
            {
                "TimesheetId": 0,
                "UserId": UserId,
                "ProjectId": this.filter.ProjectId,
                "FromDate": this.filter.FromDate,
                "ToDate": this.filter.ToDate,               
                "TeamId": TeamId,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(
                
                data => {
                    this.timesheetItems = data["TimesheetProcessList"];
                    // this.timesheetItems.forEach(element => {
                    //     element.TimeSheet_Date = this.datePipe.transform(element.TimeSheet_Date, "dd-MM-yyyy");
                    // });
                },
                err => {
                    console.log("GetTimesheetList Failed");
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);

                },
                () => {
                    this.showLoader = false;
                });
    }

    AddTimesheetForProcess() {
        console.log(this.timesheetItems);

        let objItem: any = [];
        this.timesheetItems.forEach(element => {

                let objRecord: any = {};
                objRecord.Process_Id = 0;
                objRecord.UserId = element.UserId;               
                objRecord.ProjectId = element.ProjectId;                
                objRecord.TimeSpent = element.TimeSpent;
                objRecord.Adjustment = element.NotBillableTime == "" ? 0 : element.NotBillableTime;
                objRecord.TimeSheetIdString = element.TimesheetIdList;
                objRecord.Created_By = this.userDetail.SiteUserId;
                objRecord.FromDate = element.FromDate;
                objRecord.ToDate = element.ToDate;
                objRecord.UserRate = 0;
                objRecord.Currency = 0;
                objItem.push(objRecord);

        });
        console.log(JSON.stringify(objItem));
        if (objItem.length > 0) {
            let objTimesheet: any = { "TimesheetProcessList": objItem };
            this._httpService.ajaxPost('TimesheetProcess/AddTimesheetForProcess', objTimesheet).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        //if (message[0] == "warning") {
                        //    //vm.isWarning = true;
                        //}
                        msg[0] = msg[0].toLowerCase();
                        //this._toasterService.pop(msg[0], msg[1]);
                        this.GetTimesheetForProcess(true);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                }
            );
        }
        else {
            this._sharedService.ShowMessage("error|Enter atleast one record");
        }
    }


    GetBillableTime(data)
    {
         data.BillableTime = data.TimeSpent + Number(data.NotBillableTime);
         if(data.BillableTime <0)
         {
            this._sharedService.ShowMessage("error|Please enter Valid time.");
            data.BillableTime =data.TimeSpent;
            data.NotBillableTime = 0;
         }
    }

    public clearFilter() {
        this.filter = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'), 'TeamId': "", 'UserId': "" };
        this.filter.TeamId = "";

        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        this.filter.FromDate = newDate;

        $('#projectIdFilter').select2().val("").trigger("change");
        $('#userIdFilter').select2().val("").trigger("change");

    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ProcessBills/processBills.component.ts
 **/